import { useMutation, useQueryClient } from 'react-query';
import { setGTRBFlag, SetGTRBFlagRequest, GTRBFlagStatus } from 'src/utils/Queries';

/**
 * Mutation for editing a single GTRB featureLaunchConfig flag (SetGTRBFlag, MCM TM-141073 Phase 2a).
 * Individual immediate write — one call per flag toggle, no buffering. On success the GTRB config query
 * for the FC is invalidated so the section refetches the authoritative post-write state.
 */
export function useSetGTRBFlag(fcName: string | undefined)
{
    const queryClient = useQueryClient();
    return useMutation<GTRBFlagStatus, Error, SetGTRBFlagRequest>(
        (request: SetGTRBFlagRequest) => setGTRBFlag(request),
        {
            onSuccess: () =>
            {
                if (fcName)
                {
                    queryClient.invalidateQueries(['gtrb-config', fcName]);
                }
            },
        }
    );
}
